// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_e1-2";
export var aiChatCartContainerExit = "_e1-4";
export var aiChatContainerLarge = "_e1-0";
export var aiChatContainerSmall = "_e1-1";
export var aiChatIcon = "_e1-6";
export var slideInFromRight = "_e1-3";
export var slideOutToRight = "_e1-5";